// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content_1l7di","blue":"index_blue_1_9lb","red":"index_red_VP0HS"};